export var ValuationPropertyTableHeadingEnum;
(function (ValuationPropertyTableHeadingEnum) {
    ValuationPropertyTableHeadingEnum["Description"] = "Description";
    ValuationPropertyTableHeadingEnum["SgCode"] = "SG code";
    ValuationPropertyTableHeadingEnum["FarmNumber"] = "Farm number";
    ValuationPropertyTableHeadingEnum["ErfNumber"] = "Erf Number";
    ValuationPropertyTableHeadingEnum["UnitNumber"] = "Unit Number";
    ValuationPropertyTableHeadingEnum["Address"] = "Address";
    ValuationPropertyTableHeadingEnum["ErfSize"] = "Erf size";
    ValuationPropertyTableHeadingEnum["PublicFieldCard"] = "Public field Card";
    ValuationPropertyTableHeadingEnum["MunicipalFieldCard"] = "Municipal field card";
})(ValuationPropertyTableHeadingEnum || (ValuationPropertyTableHeadingEnum = {}));
export const ValuationPropertyTableHeadingLookup = new Map([
    [ValuationPropertyTableHeadingEnum.Description, "description"],
    [ValuationPropertyTableHeadingEnum.SgCode, "sgCode"],
    [ValuationPropertyTableHeadingEnum.FarmNumber, "farmNumber"],
    [ValuationPropertyTableHeadingEnum.ErfNumber, "erfNumber"],
    [ValuationPropertyTableHeadingEnum.UnitNumber, "unitNumber"],
    [ValuationPropertyTableHeadingEnum.Address, "address"],
    [ValuationPropertyTableHeadingEnum.ErfSize, "erfSize"]
]);
